import {combineReducers} from 'redux';
import {apiTabSelectionParam} from "./ApiTabSelectionParam/ApiTabSelectionParamReducer";
import {apiSelectionParam} from "./ApiSelectionParam/ApiSelectionParamReducer";
import { routerReducer } from 'react-router-redux';

//DEPRECATED REDUCERS
import reducers from '../reducers/reducers';

export const appReducer = combineReducers({
   apiTabSelectionParam,
   apiSelectionParam,
   //DEPRECATED REDUCERS
   ...reducers,
   router: routerReducer
});
